import { useEffect } from "react"
import { useShallow } from "zustand/react/shallow"
import { useNotificationStore } from "../stores/notificationStore"

export const useNotifications = () => {
  const { unreadCount, notifications, totalElements, isLoadingList, isLoadingMore, preferences, isLoadingPreferences } =
    useNotificationStore(
      useShallow((state) => ({
        unreadCount: state.unreadCount,
        notifications: state.notifications,
        totalElements: state.totalElements,
        isLoadingList: state.isLoadingList,
        isLoadingMore: state.isLoadingMore,
        preferences: state.preferences,
        isLoadingPreferences: state.isLoadingPreferences,
      })),
    )

  const fetchUnreadCount = useNotificationStore((state) => state.fetchUnreadCount)
  const fetchNotifications = useNotificationStore((state) => state.fetchNotifications)
  const fetchMoreNotifications = useNotificationStore((state) => state.fetchMoreNotifications)
  const fetchPreferences = useNotificationStore((state) => state.fetchPreferences)
  const updatePreference = useNotificationStore((state) => state.updatePreference)
  const markAsRead = useNotificationStore((state) => state.markAsRead)
  const markAllAsRead = useNotificationStore((state) => state.markAllAsRead)
  const reset = useNotificationStore((state) => state.reset)

  useEffect(() => {
    useNotificationStore.getState().fetchUnreadCount()
    useNotificationStore.getState().fetchNotifications()
    useNotificationStore.getState().fetchPreferences()
  }, [])

  return {
    unreadCount,
    notifications,
    totalElements,
    isLoadingList,
    isLoadingMore,
    preferences,
    isLoadingPreferences,
    fetchUnreadCount,
    fetchNotifications,
    fetchMoreNotifications,
    fetchPreferences,
    updatePreference,
    markAsRead,
    markAllAsRead,
    reset,
  }
}
